import { Suspense, useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Footer from "./common-components/Footer";
import Header from "./common-components/Header";
import Sidebar from "./common-components/Sidebar";
import {
  IDLE_TIMEOUT,
  PROMPT_BEFORE_IDLE,
  SessionData,
} from "../../session/lib";
import { getSession, SessionLogout } from "../../session/session";
import WorkContractRegister from "./pages/WorkContractRegister";
import FabricInwardRegister from "./pages/FabricInwardRegister";
import FabricOutwardRegister from "./pages/FabricOutwardRegister";
import PageNotFound from "../../PageNotFound";
import StatusUpdate from "./pages/StatusUpdate";
import { useIdleTimer } from "react-idle-timer";
import IdleTimerModal from "../IdleTimeout/IdleTimerModal";

function DashboardHome() {
  const [session, setSession] = useState<SessionData>();

  useEffect(() => {
    getSession().then((sess) => {
      const data: SessionData = JSON.parse(sess!);
      setSession(data);
      // console.log("header-session")
      // console.log(session)
      if (!data.isLoggedIn) {
        navigate("/login");
      }
    });

    // eslint-disable-next-line
  }, []);

  const navigate = useNavigate();

  const cookieSessionName = session ? session.userName : "Anonymous";

  // idle timer
  const [idleModalopen, setIdleModalopen] = useState<boolean>(false);

  const onIdle = async () => {
    setIdleModalopen(false);
    await SessionLogout();
    navigate("/login");
  };

  const onPrompt = () => {
    setIdleModalopen(true);
  };

  const { activate } = useIdleTimer({
    onIdle,
    onAction: () => {
      handleStillHere();
    },
    onPrompt,
    timeout: IDLE_TIMEOUT,
    promptBeforeIdle: PROMPT_BEFORE_IDLE,
    throttle: 500,
  });

  const handleStillHere = () => {
    setIdleModalopen(false);
    activate();
  };

  return (
    <div className="flex mw-100 flex-row">
      {/* sidebar */}

      <Sidebar />

      {/* main screen */}

      <div className="main-screen h-screen w-screen overflow-y-auto">
        {/* header */}

        <Header
          cookieSessionName={
            cookieSessionName ? cookieSessionName.toString() : "Anonymous"
          }
        />

        {/* header end */}
        <div className="mx-auto dark:bg-slate-700">
          {/* <h4 className="mx-3">Good {greet}!</h4> */}
          <div className="mx-auto w-full p-2">
            <Suspense fallback={<h3>Loading...</h3>}>
              <Routes>
                <Route
                  path="/work-contract-register"
                  element={<WorkContractRegister />}
                />
                <Route
                  path="/fabric-inward-register"
                  element={<FabricInwardRegister />}
                />
                <Route
                  path="/fabric-outward-register"
                  element={<FabricOutwardRegister />}
                />
                <Route path="/status-update" element={<StatusUpdate />} />
                <Route path="/*" element={<PageNotFound />} />
              </Routes>
            </Suspense>
          </div>
        </div>

        {/* footer */}
        <Footer />
      </div>

      <IdleTimerModal isOpen={idleModalopen} />
    </div>
  );
}

export default DashboardHome;
